module.exports = __webpack_public_path__ + "img/p-3-1-1.34e94b4f.jpg";